import 'arrayq';
import { createSelector } from 'reselect';

import { Motion, spring } from 'react-motion';
import { PureConnect, React } from '../../react';
import { FontIcon } from 'react-toolbox/lib/font_icon/FontIcon';
import Button from 'react-toolbox/lib/button/Button';
import { bookmarksResource } from '../bookmarks/resource';
import { categoriesResource } from '../categories/resource';
import { beheerResource as adminResource } from '../../admin/resource';
import flyoverSelectors from '../flyover/selectors';
import ModalPlain from '../modal/plain';
import { notesResource } from '../notes/resource';

import RETRY from './actions/RETRY';

import cx from './style.less';

const notesWithErrorsSelectors = createSelector(notesResource.selectors.items, (items) => items.qWhere(notesResource.fields.error));
const categoriesWithErrorsSelectors = createSelector(categoriesResource.selectors.items, (items) => items.qWhere(categoriesResource.fields.error));
const bookmarksWithErrorsSelectors = createSelector(bookmarksResource.selectors.items, (items) => items.qWhere(bookmarksResource.fields.error));
const AdminWithErrorsSelectors = createSelector(adminResource.selectors.items, (items) => items.qWhere(adminResource.fields.error));
const hasErrorsSelector = createSelector(
    notesWithErrorsSelectors,
    categoriesWithErrorsSelectors,
    bookmarksWithErrorsSelectors,
    AdminWithErrorsSelectors,
    (notes, categories, bookmarks, admin) => notes.length > 0 || categories.length > 0 || bookmarks.length > 0 || admin.length > 0,
);

/* tslint:disable */
const styles = [
    { translateY: 450, opacity: 0 },
    { translateY: spring(450), opacity: spring(0) },
    { translateY: spring(355), opacity: spring(1) },
    { translateY: spring(0), opacity: spring(1) },
];
function getStyleIndex(flyoverVisible: boolean, errors: boolean) {
    if (flyoverVisible && errors) { return 3; }
    if (errors) { return 2; }
    return 1;
}
/* tslint:enable */

export default PureConnect(`Flyover`)(
    (state) => ({
        flyoverVisible: flyoverSelectors.visible(state),
        hasErrors: hasErrorsSelector(state),
    }),
    (dispatch) => ({
        retry: () => dispatch(RETRY({ })),
    }),
    ({ flyoverVisible, hasErrors, retry }) => {
        return (
            <Motion defaultStyle={styles[0] as any} style={styles[getStyleIndex(flyoverVisible, hasErrors)]}>
                {(style: any) => style.opacity === 0 ? null : (
                    (
                        <ModalPlain visible type="flyover2" transform={{ ...style, translateY: `${style.translateY}px` }}>
                            <div className={cx('component')}>
                                <div className={cx('icon')}>
                                    <FontIcon className={cx('icon__icon')} value="warning" />
                                </div>
                                <div className={cx('content')}>
                                    <div className={cx('description')}>
                                        Kon niet alles bijwerken
                                    </div>
                                    <div className={cx('actions')}>
                                        <Button primary raised onClick={retry}>Opnieuw proberen</Button>
                                    </div>
                                </div>
                            </div>
                        </ModalPlain>
                    ))}
            </Motion>
        );
    });



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/errorControl/index.tsx